module.exports = __webpack_public_path__ + "img/downIcon.26725d63.svg";